import { useEffect, useState } from 'react'

import { formatStream, readMessageStream } from './utils'
import { Message } from '../message'
import { MessageStreamType } from '../messageList'

export function StreamingMessage({ stream }: { stream: MessageStreamType }) {
  const [content, setContent] = useState('')

  useEffect(() => {
    if (stream.locked) return
    readMessageStream(stream, (chunk) => {
      setContent((prev) => prev + formatStream(chunk))
    })
  }, [stream])

  return <Message type="incoming" message={content} />
}
